import React from 'react';

import { Result } from '../types';

export interface SearchResultsContextType {
  activeFilters: { tags: string[] };
  toggleFilters: (tags: string[]) => void;
  loadMoreSearchResults: () => void;
  searchResults: Result[];
  isLoadingMoreResults: boolean;
  noMoreResults: boolean;
}

const defaultValues: SearchResultsContextType = {
  activeFilters: { tags: [] },
  toggleFilters: () => {},
  loadMoreSearchResults: () => {},
  searchResults: [],
  isLoadingMoreResults: false,
  noMoreResults: false,
};

export const SearchResultsContext = React.createContext<SearchResultsContextType>(defaultValues);

export const useSearchResultsContext = () => React.useContext(SearchResultsContext);
